import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { Modal, Button, Text, Group, rem, Tooltip } from "@mantine/core";
import { useDisclosure, useViewportSize } from "@mantine/hooks";
import { Cubby } from "../stores/Cubby";

import {
  IconPhoto,
  IconDownload,
  IconArrowRight,
  IconInfoHexagon,
  IconSettings,
  IconInfoCircle,
  IconClock,
  IconApps,
} from "@tabler/icons-react";
import { MODALS } from "../helpers/constants";
import ActionsMenu from "./actionsMenu";
import DataMenu from "./dataMenu";
import RunningStatus from "./dataDisplay/runningStatus";

const LesserButtons = observer(({ cubby }: { cubby: Cubby }) => {
  const { width } = useViewportSize();
  const isMobile = width < 768; // Adjust this breakpoint as needed

  const makeUptimeCTA = () => {
    if (cubby.remainingDaysOfGuaranteedUptime == 0) {
      return "Get Uptime";
    }
    return "Extend Uptime";
  };
  const justify = isMobile ? "flex-start" : "flex-end";
  const isAppsButtonDisabled = () => {
    const hasSomeLiquidity =
      cubby.inboundLiquidity > 0 || cubby.outboundLiquidity > 0;
    // console.log("has some liquidity", hasSomeLiquidity);
    if (
      !cubby.isConsideredReadyForBasicLightningApiRequests ||
      !hasSomeLiquidity
    ) {
      return true;
    }
    {
      return false;
    }
  };
  return (
    <>
      <Group justify={justify}>
        <Tooltip
          multiline
          w={300}
          disabled={!isAppsButtonDisabled()}
          withArrow
          transitionProps={{ duration: 200 }}
          label={
            "To connect apps, you need a Lightning channel. Please use the [Get Inbound] or [Open Channel] button to get a Lightning channel."
          }
        >
          <Button
            leftSection={<IconApps />}
            size="sm"
            variant="default"
            aria-label="connect apps"
            disabled={isAppsButtonDisabled()}
            onClick={() => cubby.setModal(MODALS.CONNECT_APPS)}
          >
            Apps
          </Button>
        </Tooltip>
        <Button
          leftSection={<IconClock />}
          size="sm"
          variant="default"
          aria-label="manage uptime"
          onClick={() => cubby.setModal(MODALS.MANAGE_UPTIME)}
        >
          {makeUptimeCTA()}
        </Button>

        {cubby.isConsideredReadyForBasicLightningApiRequests ? (
          <Button
            leftSection={<IconInfoCircle />}
            size="sm"
            variant="default"
            aria-label="about this node"
            onClick={() => cubby.setModal(MODALS.NODE_IDENTITY)}
          >
            Node Info
          </Button>
        ) : null}
        <ActionsMenu cubby={cubby} />
        {cubby.hasSomeHistory && <DataMenu cubby={cubby} />}
      </Group>
    </>
  );
});

export default LesserButtons;
